module.exports = (file) => () => import(`@/public/pages/${file}.vue`)